import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-meenu',
  templateUrl: './meenu.component.html',
  styleUrls: ['./meenu.component.scss']
})
export class MeenuComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getMeenu();
  }
}
